// Simplified Convex API wrapper to avoid deep type instantiation issues
import { useMutation as useConvexMutation, useQuery as useConvexQuery } from 'convex/react';

// Create type-safe API references without complex type inference
const createApiRef = (module: string, func: string) => ({ module, func });

export const api = {
  tournaments: {
    createTournament: createApiRef('tournaments', 'createTournament'),
    getTournamentByInvite: createApiRef('tournaments', 'getTournamentByInvite'),
    getTournamentDetails: createApiRef('tournaments', 'getTournamentDetails'),
    lockTournament: createApiRef('tournaments', 'lockTournament'),
  },
  players: {
    sendVerificationCode: createApiRef('players', 'sendVerificationCode'),
    verifyPlayer: createApiRef('players', 'verifyPlayer'),
    registerForTournament: createApiRef('players', 'registerForTournament'),
    removeFromTournament: createApiRef('players', 'removeFromTournament'),
  },
};

// Custom hooks that use the simplified API references
export const useMutation = (apiRef: { module: string; func: string }) => {
  const mutation = useConvexMutation(`${apiRef.module}.js:${apiRef.func}` as any);
  return mutation;
};

export const useQuery = (apiRef: { module: string; func: string }, args?: any) => {
  const query = useConvexQuery(`${apiRef.module}.js:${apiRef.func}` as any, args);
  return query;
};

// Export common types
export type Id<T> = string;